// 登录注册等表单请求的错误提示
export const statusCodeMapping = {
  100: 'lang135',
  101: 'lang136',
  102: 'lang137',
  103: 'lang138',
  104: 'lang139',
  105: 'lang140',
  106: 'lang141',
  107: 'lang142',
  108: 'lang143',
  109: 'lang144',
  110: 'lang145',
  111: 'lang146',
  100001: 'lang147',
  100002: 'lang148',
  100003: 'lang149',
  100004: 'lang150',
  11000: 'lang151',
  200: 'lang152',
  401: 'lang153',
  404: 'lang154',
  409: 'lang155',
  420: 'lang156',
  422: 'lang157',
  430: 'lang158',
  453: 'lang159',
  521: 'lang160',
  522: 'lang161',
  524: 'lang162',
  531: 'lang163',
  google_vertitication_fail: 'lang164 ',
  register_vcode: 'lang165',
  other: 'lang166'
};

// 国家id与对应的语言码
export const countryLangMap = {
  ID: 'lang060',
  IN: 'lang061',
  VN: 'lang062',
  TH: 'lang063',
  SA: 'lang064',
  MY: 'lang065',
  PH: 'lang066',
  KH: 'lang067',
  SG: 'lang068',
  IQ: 'lang069',
  TW: 'lang070',
  KR: 'lang071',
  KW: 'lang072',
  LA: 'lang073',
  RU: 'lang074',
  CN: 'lang075',
  US: 'lang076',
  BD: 'lang077',
  QA: 'lang078',
  TR: 'lang079',
  BR: 'lang080',
  JP: 'lang081',
  MA: 'lang082',
  PK: 'lang083',
  HK: 'lang084',
  AE: 'lang085',
  JO: 'lang086',
  CA: 'lang087',
  AU: 'lang088',
  EG: 'lang089',
  KZ: 'lang190',
  OM: 'lang191',
  NP: 'lang192',
  BN: 'lang193',
  LB: 'lang194',
  KG: 'lang195',
  BH: 'lang196',
  IR: 'lang197',
  PS: 'lang198',
  AZ: 'lang199',
  IL: 'lang200',
  CY: 'lang201',
  AM: 'lang202',
  AF: 'lang203',
  MO: 'lang204',
  GE: 'lang205',
  LK: 'lang206',
  YE: 'lang207',
  UZ: 'lang208',
  TJ: 'lang209',
  MV: 'lang210',
  MM: 'lang211',
  MX: 'lang212',
  AR: 'lang213',
  CO: 'lang214',
  PE: 'lang215',
  EC: 'lang216',
  CL: 'lang217',
  BO: 'lang218',
  NI: 'lang219',
  DO: 'lang220',
  GT: 'lang221',
  CR: 'lang222',
  PA: 'lang223',
  PR: 'lang224',
  VE: 'lang225',
  DE: 'lang226',
  GB: 'lang227',
  FR: 'lang228',
  RO: 'lang229',
  BY: 'lang230',
  UA: 'lang231',
  SE: 'lang232',
  IT: 'lang233',
  ES: 'lang234',
  PT: 'lang235',
  NL: 'lang236',
  GR: 'lang237',
  CH: 'lang238',
  AT: 'lang239',
  NO: 'lang240',
  BE: 'lang241',
  IE: 'lang242',
  FI: 'lang243',
  BG: 'lang244',
  DZ: 'lang245',
  LY: 'lang246',
  TN: 'lang247',
  SD: 'lang248',
  CI: 'lang249',
  NZ: 'lang250'
};
